<template>
    <div>
        <!-- Dialog Genérico -->
        <v-dialog content-class="br-15" scrollable v-model="dialog" width="600">
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary-degrade white--text fix-flex"
                >
                    <v-toolbar-title>
                        {{ dialogTitulo }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialog = false"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-5">
                    {{ dialogTexto }}
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog Aprovar -->
        <v-dialog content-class="br-15" v-model="dialogAprovar" width="600">
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary degrade white--text fix-flex"
                >
                    <v-toolbar-title>{{ dialogTitulo }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogAprovar = false"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-4">
                    {{ dialogTexto }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="new-button ml-auto mb-2 mr-2 px-3"
                        color="error"
                        @click="dialogAprovar = false"
                    >
                        <v-icon class="mr-3">mdi-check-circle</v-icon>
                        Não, não aprovar
                    </v-btn>
                    <v-btn
                        class="new-button mb-2 px-3"
                        color="primary"
                        @click="aprovarAcordo('aprovar')"
                    >
                        <v-icon class="mr-3">mdi-check-circle</v-icon>
                        Sim, aprovar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Reprovar -->
        <v-dialog content-class="br-15" v-model="dialogReprovar" width="600">
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="error white--text fix-flex"
                >
                    <v-toolbar-title>
                        {{ dialogTitulo }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogReprovar = false"
                    >
                        <v-icon size="18px" color="error">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-4">
                    {{ dialogTexto }}
                    <br /><br />
                    <v-form v-model="isJustificativa">
                        <v-select
                            label="Justificativa"
                            v-model="justificativa"
                            :items="justificativasReprovacao"
                            :rules="regra.justificativa"
                            :menu-props="menuProps"
                            class="input-cinza"
                            outlined
                            dense
                        ></v-select>
                        <v-textarea
                            outlined
                            label="Observação"
                            class="input-cinza"
                            v-model="observacao"
                        ></v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="new-button ml-auto mb-2 mr-2 px-3"
                        :disabled="!isJustificativa"
                        @click="aprovarAcordo('reprovar')"
                    >
                        Reprovar Acordo
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Cancelar -->
        <v-dialog content-class="br-15" v-model="dialogCancelar" width="600">
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="error white--text fix-flex"
                >
                    <v-toolbar-title>
                        {{ dialogTitulo }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogCancelar = false"
                    >
                        <v-icon size="18px" color="error">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-4">
                    {{ dialogTexto }}
                    <br /><br />
                    <v-form v-model="isJustificativaCancelamento">
                        <v-select
                            label="Justificativa"
                            v-model="justificativaCancelamento"
                            :items="justificativasCancelamento"
                            :rules="regra.justificativa"
                            :menu-props="menuProps"
                            class="input-cinza"
                            outlined
                            dense
                        ></v-select>
                        <v-textarea
                            outlined
                            label="Observação"
                            class="input-cinza"
                            v-model="observacaoCancelamento"
                        ></v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        class="new-button ml-auto mb-2 mr-2 px-3"
                        :disabled="!isJustificativaCancelamento"
                        @click="cancelarAcordo()"
                    >
                        Cancelar Acordo
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Histórico -->
        <v-dialog scrollable content-class="br-15" v-model="dialogHistorico" width="80%">
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary-degrade white--text fix-flex"
                >
                    <v-toolbar-title>
                        {{ dialogTitulo }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogHistorico = false"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="pa-5 pb-0">
                    <v-data-table
                        :headers="headersHistorico"
                        :items="historicoItems"
                        item-key="id"
                        :items-per-page="5"
                        :footer-props="{
                            'items-per-page-options': [5, 10, 15, 25, 50],
                            itemsPerPageText: 'Linhas por páginas',
                            ofText: 'de',
                            pageText: '{0}-{1} de {2}',
                        }"
                        class="elevation-0 tabela"
                    ></v-data-table>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="new-button mb-2 mr-2 px-3"
                        @click="dialogHistorico = false"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Visualizar Planograma -->
        <v-dialog content-class="br-15" scrollable v-model="dialogImagem" width="700">
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary-degrade white--text fix-flex"
                >
                    <v-toolbar-title>
                        {{ dialogTitulo }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogImagem = false"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-5">
                    <div v-html="htmlPlanograma"></div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog Editar Planograma -->
        <v-dialog content-class="br-15" scrollable v-model="dialogEditarPlanograma" width="700">
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary-degrade white--text fix-flex"
                >
                    <v-toolbar-title>
                        {{ dialogTitulo }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogEditarPlanograma = false"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-5">
                    <div v-if="htmlPlanograma" class="mb-4">
                        <div v-html="htmlPlanograma"></div>
                        <v-btn
                            color="error"
                            small
                            class="new-button mt-2"
                            @click="deletePlanograma"
                        >
                            <v-icon left>mdi-close</v-icon> Remover planograma
                        </v-btn>
                    </div>
                    <v-file-input
                        v-else
                        v-model="filePlanograma"
                        label="Planograma"
                        class="input-cinza"
                        prepend-icon=""
                        prepend-inner-icon="mdi-paperclip"
                        accept=".pdf,.png,.jpg,.jpeg"
                        truncate-length="30"
                        outlined
                        dense
                    ></v-file-input>
                    <v-textarea
                        v-model="comentarioPlanograma"
                        outlined
                        dense
                        rows="3"
                        label="Comentários Gerais"
                        class="input-cinza mt-2"
                    ></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="new-button mb-2 mr-2 px-3"
                        @click="editarPlanograma()"
                    >
                        Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Erros -->
        <v-dialog
            content-class="br-15"
            v-model="dialogoErro.open"
            persistent
            width="90%"
        >
            <v-card>
                <v-card-title class="subtitle-1 error white--text">
                    Erro(s) ao Salvar Acordo(s)
                </v-card-title>
                <v-card-text class="mt-4">
                    <v-data-table
                        :headers="listaHeaderErro"
                        :items="listaErro"
                        :items-per-page="5"
                        :options.sync="paginationErro"
                        class="elevation-1 data-table-2"
                    ></v-data-table>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <download-csv
                        :data="listaErro"
                        :labels="listaErroLabels"
                        name="erros.csv"
                        delimiter=";"
                    >
                        <v-btn color="primary">
                            <v-icon left>mdi-microsoft-excel</v-icon>
                            Exportar
                        </v-btn>
                    </download-csv>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click="dialogoErro.open = false"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-overlay :value="carregando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar
            v-model="alerta"
            :color="alertaColor"
            :timeout="alertaTimeout"
            top
            style="z-index: 400"
        >
            <v-alert :type="alertaColor">
                {{ alertaTexto }}
            </v-alert>
            <v-btn dark text class="float-right" @click="alerta = false">
                Fechar
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    data() {
        return {
            carregando: false,
            dialog: false,
            dialogAprovar: false,
            dialogReprovar: false,
            dialogCancelar: false,
            dialogHistorico: false,
            dialogImagem: false,
            dialogEditarPlanograma: false,
            dialogTitulo: "",
            dialogTexto: "",
            item: {},
            // Planograma
            htmlPlanograma: null,
            filePlanograma: null,
            comentarioPlanograma: null,
            planogramaRemovido: false,
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: "select-outline",
                transition: "slide-y-transition",
            },
            // Aprovar/Reprovar
            justificativa: null,
            observacao: null,
            isJustificativa: false,
            justificativasReprovacao: [
                { text: "Preço inadequado", value: "Preço inadequado" },
                { text: "Produto indisponível", value: "Produto indisponível" },
                { text: "Fornecedor não autorizado", value: "Fornecedor não autorizado" },
                { text: "Outros", value: "Outros" },
            ],
            // Cancelar
            justificativaCancelamento: null,
            observacaoCancelamento: null,
            isJustificativaCancelamento: false,
            justificativasCancelamento: [
                { text: "Solicitação do fornecedor", value: "Solicitação do fornecedor" },
                { text: "Erro de cadastro", value: "Erro de cadastro" },
                { text: "Mudança de estratégia", value: "Mudança de estratégia" },
                { text: "Outros", value: "Outros" },
            ],
            // Histórico
            headersHistorico: [
                { text: "Data", value: "data_criacao_formatado", align: "center" },
                { text: "Usuário", value: "usuario_nome", align: "center" },
                { text: "Ação", value: "processo", align: "center" },
                { text: "Observação", value: "detalhe", align: "center" },
            ],
            historicoItems: [],
            // Erros
            dialogoErro: { open: false },
            listaHeaderErro: [
                { text: "Descrição", value: "msg", align: "center" },
            ],
            listaErro: [],
            listaErroLabels: { msg: "Descrição do Erro" },
            paginationErro: {},
            regra: {
                justificativa: [
                    (v) => !!v || "O campo justificativa é obrigatório",
                ],
            },
            alerta: false,
            alertaTexto: "",
            alertaColor: "error",
            alertaTimeout: 3000,
        };
    },
    methods: {
        aprovar(item) {
            if (item) {
                this.item = item;
                this.dialogTitulo = `Aprovar Acordo GC #${item.id_acordo_gc}`;
                this.dialogTexto = `Deseja aprovar o acordo GC #${item.id_acordo_gc}?`;
            } else {
                this.item = {};
                this.dialogTitulo = "Aprovar Acordos GC selecionados";
                this.dialogTexto = "Deseja aprovar os acordos GC selecionados?";
            }
            this.dialogAprovar = true;
        },
        reprovar(item) {
            this.justificativa = null;
            this.observacao = null;
            if (item) {
                this.item = item;
                this.dialogTitulo = `Reprovar Acordo GC #${item.id_acordo_gc}`;
                this.dialogTexto = `Deseja reprovar o acordo GC #${item.id_acordo_gc}? Selecione uma justificativa.`;
            } else {
                this.item = {};
                this.dialogTitulo = "Reprovar Acordos GC selecionados";
                this.dialogTexto = "Deseja reprovar os acordos GC selecionados? Selecione uma justificativa.";
            }
            this.dialogReprovar = true;
        },
        cancelar(item) {
            this.justificativaCancelamento = null;
            this.observacaoCancelamento = null;
            this.item = item;
            this.dialogTitulo = `Cancelar Acordo GC #${item.id_acordo_gc}`;
            this.dialogTexto = `Deseja cancelar o acordo GC #${item.id_acordo_gc}? Selecione uma justificativa.`;
            this.dialogCancelar = true;
        },
        async aprovarAcordo(tipo) {
            this.carregando = true;
            var data = {
                tipo: tipo,
                id_acordo_gc: this.item.id_acordo_gc || null,
                justificativa: this.justificativa,
                observacao: this.observacao,
            };
            this.$emit("aprovarAcordo", data);
            this.dialogAprovar = false;
            this.dialogReprovar = false;
            this.carregando = false;
        },
        async cancelarAcordo() {
            this.carregando = true;
            var data = {
                id_acordo_gc: this.item.id_acordo_gc,
                justificativa: this.justificativaCancelamento,
                observacao: this.observacaoCancelamento,
            };

            try {
                var response = await this.$http().post(
                    "/acordoGC/cancelar",
                    { data: data }
                );
                if (response.data.success) {
                    this.$emit("filtrar");
                    this.dialogCancelar = false;
                } else {
                    this.alerta = true;
                    this.alertaColor = "error";
                    this.alertaTimeout = -1;
                    this.alertaTexto = response.data.msg || "Erro ao cancelar acordo.";
                }
            } catch (error) {
                this.$emit("filtrar");
                this.dialogCancelar = false;
            }
            this.carregando = false;
        },
        async historico(item) {
            this.carregando = true;
            this.item = item;
            this.dialogTitulo = `Histórico - Acordo GC #${item.id_acordo_gc}`;

            const response = await this.$http().post(
                "/acordoGC/historico",
                { data: { id_acordo_gc: item.id_acordo_gc } }
            );
            this.historicoItems = response.data.result || [];

            this.dialogHistorico = true;
            this.carregando = false;
        },
        montarPlanograma(url) {
            if (!url) return "";
            const src = this.$arquivoProtegido(url);
            if (url.substr(-3).toLowerCase() === "pdf") {
                return `<embed src="${src}" type="application/pdf" width="100%" height="450px">`;
            }
            return `<div class="wrap-image"><img src="${src}" class="responsive" style="max-width: 100%"></div>`;
        },
        planograma(item) {
            this.item = item;
            this.dialogTitulo = `Planograma - Acordo GC #${item.id_acordo_gc}`;
            this.htmlPlanograma = this.montarPlanograma(item.planograma);
            this.dialogImagem = true;
        },
        planogramaEditar(item) {
            this.item = item;
            this.dialogTitulo = `Editar Planograma - Acordo GC #${item.id_acordo_gc}`;
            this.filePlanograma = null;
            this.planogramaRemovido = false;
            this.comentarioPlanograma = item.comentario || null;
            this.htmlPlanograma = item.planograma
                ? this.montarPlanograma(item.planograma)
                : null;
            this.dialogEditarPlanograma = true;
        },
        deletePlanograma() {
            this.htmlPlanograma = null;
            this.filePlanograma = null;
            this.planogramaRemovido = true;
        },
        async editarPlanograma() {
            const temArquivoNovo = this.filePlanograma instanceof File;

            if (!temArquivoNovo && !this.planogramaRemovido) {
                this.dialogEditarPlanograma = false;
                return;
            }

            this.carregando = true;

            const data = {
                id_acordo_gc: this.item.id_acordo_gc,
                comentario: this.comentarioPlanograma,
                acao: temArquivoNovo ? "salvar" : "excluir",
            };

            const formData = new FormData();
            formData.append("data", JSON.stringify(data));
            if (temArquivoNovo) {
                formData.append("files", this.filePlanograma);
            }

            try {
                const response = await this.$http().post(
                    "/acordoGC/editarPlanograma",
                    formData
                );
                if (response.data.success) {
                    this.alerta = true;
                    this.alertaColor = "success";
                    this.alertaTimeout = 3000;
                    this.alertaTexto = response.data.msg || "Planograma atualizado com sucesso.";
                    this.dialogEditarPlanograma = false;
                    this.$emit("filtrar");
                } else {
                    this.alerta = true;
                    this.alertaColor = "error";
                    this.alertaTimeout = -1;
                    this.alertaTexto = response.data.msg || "Erro ao editar planograma.";
                }
            } catch (error) {
                this.alerta = true;
                this.alertaColor = "error";
                this.alertaTimeout = 5000;
                this.alertaTexto = "Erro ao editar planograma.";
            }

            this.carregando = false;
        },
    },
};
</script>
